import { Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { UploadfilePopupComponent } from 'src/app/modules/file-upload/uploadfile-popup/uploadfile-popup.component';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';

@Component({
  selector: 'app-upload-popup',
  templateUrl: './upload-popup.component.html',
  styleUrls: ['./upload-popup.component.scss'],
})
export class UploadPopupComponent {
  selectedQ88File: File | null = null;
  selectedMainFile: File | null = null;
  selectedJsonFile: File | null = null;
  @ViewChild('jsonFileInput') jsonFileInput!: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<UploadfilePopupComponent>,
    private toastr: ToastrService,
    private portRequestformService: PortRequestFormServiceService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  closeModal() {
    this.dialogRef.close();
  }

  onQ88FileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedQ88File = file;
    }
  }

  onMainFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedMainFile = file;
    }
  }

  onJsonFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.name.toLowerCase().endsWith('.json')) {
        this.selectedJsonFile = file;
      } else {
        this.toastr.warning('Only JSON files are allowed for Q88 data.');
      }
    }
  }

  removeJsonFile() {
    this.selectedJsonFile = null;
    if (this.jsonFileInput) {
      this.jsonFileInput.nativeElement.value = '';
    }
  }

  submitClick() {
    if (!this.selectedQ88File || !this.selectedMainFile) {
      this.toastr.warning('Please upload both the Q88 file and the Main file.');
      return;
    }
    this.portRequestformService
      .uploadFiles(this.selectedMainFile, this.selectedQ88File, this.selectedJsonFile)
      .subscribe({
        next: (data) => {
          this.toastr.success(ToasterMessages.FilesUpload);
          this.closeModal();
        },
        error: (error) => {
          const errMsg = error?.error?.error || error?.error?.message || ToasterMessages.Error;
          this.toastr.error(errMsg);
        }
      });
    console.log('Q88 File:', this.selectedQ88File);
    console.log('Main File:', this.selectedMainFile);
    console.log('JSON File:', this.selectedJsonFile);
  }
}
